/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetClearanceRequests = (data: any) =>
  useQuery({
    queryKey: [
      "GetClearanceRequests",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
    ],
    queryFn: ({ signal }) =>
      client(`machine/services/clearance/open/requests`, { data, signal }),
  });

export const useCancelClearanceService = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetClearanceRequests"] });
    },
  });
};

export const useAssignClearanceRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetClearanceRequests"],
      });
    },
  });
};

export const useCreateClearanceRequest = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/create/request`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useCreateMultiClearanceRequests = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/create/multiple/requests`, {
        data,
        successMessage: "Multiple requests submitted successfully!",
      }),
  });

export const useCreateClearanceBulkOrders = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/create/bulk/requests`, {
        data,
        successMessage: "Order(s) created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetClearanceRequests"],
      });
    },
  });
};

export const useGetClearanceRequestDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetClearanceRequestDetails", data?.requestId],
    queryFn: () =>
      client(`machine/services/clearance/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditClearanceJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["GetClearanceRequestDetails"],
      });
    },
  });
};

export const useUpdateRequestStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetClearanceRequestDetails"] });
    },
  });
};

export const useUpdateClearanceAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`machine/services/clearance/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetClearanceRequestDetails"] });
    },
  });
};
